import { Axios } from "../../axios.interceptor";

const h = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getComments         = (params, token)        => Axios.get("/api/v1/admin/blog/comments", { params, ...h(token) });
export const updateCommentStatus = (id, status, token)    => Axios.patch(`/api/v1/admin/blog/comments/${id}/status`, { status }, h(token));
export const deleteComment       = (id, token)            => Axios.delete(`/api/v1/admin/blog/comments/${id}`, h(token));
